import { render, staticRenderFns } from "./uploadTemplate.vue?vue&type=template&id=0d6917c8&"
import script from "./uploadTemplate.vue?vue&type=script&lang=js&"
export * from "./uploadTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports